// Step name constants
export const STEP_NAME_START = "START";
export const STEP_NAME_HOME_DETAILS = "HOME_DETAILS";
export const STEP_NAME_ADDRESS_DETAILS = "ADDRESS_DETAILS";
export const STEP_NAME_COVERS = "COVERS";
export const STEP_NAME_SUMMARY = "SUMMARY";

export const headerStepperData = [
    {
        key: STEP_NAME_START,
        title_en: "Start",
        title_ar: "ابدأ",
    },
    {
        key: STEP_NAME_HOME_DETAILS,
        title_en: "Home",
        title_ar: "المنزل",
    },
    {
        key: STEP_NAME_ADDRESS_DETAILS,
        title_en: "Address",
        title_ar: "العنوان",
    },
    {
        key: STEP_NAME_COVERS,
        title_en: "Covers",
        title_ar: "الإضافات",
    },
    {
        key: STEP_NAME_SUMMARY,
        title_en: "Pay",
        title_ar: "المراجعة والدفع",
    },
];